$(document).on('mapsLoaded', function() {

    window.TourMarker = function(options) {
        this.options = $.extend({}, options);
        this.div = $('<div class="tour-marker"/>').on('click', event => {
            Navigation.setTourWaypoint(options.index)
        });
        this.index = $('<div class="index"/>').text(this.options.index || 0).appendTo(this.div);
        if (this.options.position) this.setPosition(this.options.position);
    }

    TourMarker.prototype = Object.create(window.Marker.prototype);
});
